import { defineStore } from "pinia";
import UserStore from "@/store/user";
import { limparLocalStorageExcetoPreferencias } from "@/composables/tabela/preferenciasComReserva";
import versoes from "../assets/logVersoesSistema.js";
import config from "../config.js";
import { Auth, Amplify } from "aws-amplify";
// @ts-expect-error -- aws-exports.js não tem .d.ts (mesmo buraco de src/libs/AuthApi.ts:4);
// resolver aqui exigiria um shim de tipo para o arquivo inteiro, maior que o escopo desta tarefa (R8 pontual).
import awsconfig from "@/aws-exports.js";
Amplify.configure(awsconfig);

/**
 * `user` chega tanto como instância real de `UserModel` quanto como objeto puro
 * (`JSON.parse` abaixo); tipar os dois formatos de verdade é retrabalho maior
 * que o escopo desta tarefa (R8 pontual, T65).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function atualizaSessao(user: any) {
  localStorage.removeItem("user");
  try {
    if (user.tipo === "cliente") {
      // FIXME: cliente não está caindo nesse logout????

      await Auth.signOut();
      // FIXME: O Redirect para login não está funcionando
      // router.push('/login')
      return;
    } else {
      await Auth.federatedSignIn({ customProvider: config.PROVIDER });
    }
  } catch {
    await Auth.federatedSignIn({ customProvider: config.PROVIDER });
  }
}

export default defineStore("helpers", {
  state: () => ({
    versao: null,
  }),
  actions: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- mesmo motivo de atualizaSessao acima.
    async atualizaUser(user: any) {
      await atualizaSessao(user);
    },
    async verificaVersaoCache() {
      const userStore = UserStore();
      let versaoAtual = localStorage.getItem("versao");

      if (versoes[0].versao !== versaoAtual) {
        // eslint-disable-next-line no-console -- log operacional de invalidação de cache, não debug esquecido.
        console.error("NOVA VERSÃO DO PROGALI");
        limparLocalStorageExcetoPreferencias();
      } else if (userStore.user?.email && userStore.expiraEm < Date.now()) {
        // eslint-disable-next-line no-console -- log operacional de expiração de sessão, não debug esquecido.
        console.error("USUARIO EXPIRADO");
        // @ts-expect-error -- defeito preexistente (R11, não corrigido aqui): `getItem` devolve
        // `string | null`, e chave ausente faria `JSON.parse(null)` devolver `null`, que quebraria
        // em `user.tipo` dentro de `atualizaSessao`. Preservado e marcado, não consertado.
        await atualizaSessao(JSON.parse(localStorage.getItem("user")));
      }

      if (!versaoAtual) {
        // eslint-disable-next-line no-console -- log operacional de cache frio, não debug esquecido.
        console.error("VERSÃO NÃO ENCONTRADA NO CACHE");
        versaoAtual = versoes[0].versao;
        localStorage.setItem("versao", versaoAtual);
      }
    },
  },
});
